// Teller Online Files
import { PublicHelpTag } from 'apps/public-portal/src/app/shared/help/help-tags';
import { helpTitle } from 'apps/public-portal/src/app/shared/help/help-titles';

// Teller Online Library Files
import { HelpArticle, HelpConditional } from 'teller-online-libraries/help';

export const PAYMENT_METHODS_HELP_ARTICLES: HelpArticle[] = [
    new HelpArticle({
        tag: PublicHelpTag.PaymentMethods,
        order: 13,
        conditions: [HelpConditional.NotRedirect, HelpConditional.Users],
        bookmark: 'what-are-saved-payment-methods',
        title: helpTitle('what-are-saved-payment-methods'),
        body: '<p>Saved payment methods are a way of storing a payment method (e.g. Credit Card, '
            + 'Debit Card and E-Check) for later use.</p>'
            + '<p>At checkout, you can select a saved payment method and click the <b>Pay</b> '
            + 'button.</p>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.PaymentMethods,
        order: 14,
        conditions: [HelpConditional.NotRedirect, HelpConditional.Users],
        bookmark: 'how-to-add-saved-payment-method',
        title: helpTitle('how-to-add-saved-payment-method'),
        body: 'There are 2 ways to add a saved payment method.'
            + '<ul>'
            + '<li>You can use the <b>Save Payment Method</b> checkbox at checkout.</li>'
            + '<li>Navigate to the Payment Methods page and click the '
            + '<b>Add Payment Method</b> button at the top of the page.</li>'
            + '</ul>'
    }),
    new HelpArticle({
        tag: PublicHelpTag.PaymentMethods,
        order: 15,
        conditions: [HelpConditional.NotRedirect, HelpConditional.Users],
        bookmark: 'how-to-update-saved-payment-method',
        title: helpTitle('how-to-update-saved-payment-method'),
        body: 'In the Payment methods page, you can view your existing payment methods. To '
            + 'update a method, click the :edit: <b>Edit</b> button.'
    })
];
